import { useParams } from "react-router-dom";
import InfoChip from "../components/common/InfoChip";
import { Severity } from "../types";
import { useFetchRiderDetailsQuery, useUpdateRiderMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import { HIDDEN_PASSWORd, riderSchema } from "../configs";
import RiderForm from "../forms/Rider.form";

const EditRiderWrapper = () => {
  const { riderId } = useParams();

  if (!riderId)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Livreur introuvable"
      />
    );

  return <EditRider riderId={riderId} />;
};

interface EditRiderProps {
  riderId: string;
}

const EditRider: React.FC<EditRiderProps> = ({ riderId }) => {
  const [updateRider, { isLoading }] = useUpdateRiderMutation();
  const { data: riderDetails, isFetching } = useFetchRiderDetailsQuery(riderId);

  if (isLoading || isFetching) return <div>Chargement...</div>;

  if (!riderDetails)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Livreur introuvable"
      />
    );

  const initialValues = {
    ...riderDetails,
    password: HIDDEN_PASSWORd,
  };

  return (
    <div className="w-full flex flex-col items-center p-4">
      <RiderForm
        initialValues={initialValues}
        validationSchema={riderSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          if (values.password === HIDDEN_PASSWORd) {
            delete values.password;
          }

          const result = await updateRider({
            riderId,
            body: values,
          });

          if (!result.error) {
            showToast("Livreur mis à jour avec succès", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default EditRiderWrapper;
